import api from "../api/axios";

export const ROLE_QUERY_KEY = ["role"];

export interface CreateRolePayload {name: string; slug: string;description?: string;}
export interface UpdateRolePayload extends CreateRolePayload {}

export const rolesService = {
  getAllRole: async () => {
    const response = await api.get(`api/roles`);
    return response.data;
  },
  createRole: async (payload: CreateRolePayload) => {
    const response = await api.post(`api/roles`, payload);
    return response.data;
  },
  updateRole: async (id: number, payload: UpdateRolePayload) => {
    const response = await api.put(`api/roles/${id}`, payload);
    return response.data;
  },
  deleteRole: async (id: number) => {
    const response = await api.delete(`api/roles/${id}`);
    return response.data;
  },
};